import React, { useState, useEffect } from 'react';
// import Select2 from 'react-select2-wrapper';
// import 'select2/dist/css/select2.min.css';
import Select from 'react-select'
import { UTILS } from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';

export const AddClient = ({ setgetId, client, cardDetail }) => {
  // console.log('Client', client);

  const [formData, setFormData] = useState({
    client_id: '',
  });
  let [addClientDetails, setAddClientDetails] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  useEffect(() => {
    setAddClientDetails(cardDetail);
  }, []);

  const addClientFunc = async () => {
    if (!formData.client_id) {
      alert('Select User');
      return;
    }

    // console.log('formData', formData);

    const randomString = Math.random().toString(36).substring(2, 5);
    const url =
      UTILS.API_url + `board/v1/board-list-cards/change-client?${randomString}`;
    const data = new FormData();

    data.append('task_id', cardDetail?.id); // Assuming task_id is the user_id in your context
    data.append('client_id', formData.client_id);

    try {
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      // console.log('response', response);

      if (response.status === 200) {
        setFormData({
          client_id: '',
          title: '',
        });
        setgetId(null);
        toast.success('Successfully Added');
      }
    } catch (error) {
      toast.error(error.response?.data?.errors?.client_id?.[0]);
    }
  };

  useEffect(() => {
    const initialValue = formData?.client_id || (addClientDetails?.client?.id || null);
    
    // Find the corresponding option object based on the initial value
    const initialOption = client.find(clien => clien.id === initialValue);

    setSelectedClient(initialOption ? { value: initialOption.id, label: initialOption.combine } : null);
  }, [formData, addClientDetails, client]);
  

  //  console.log("addClientDetails",addClientDetails);
   

  return (
    <div>
      <button className="close-btn-pop close-member">
        <span
          className="material-symbols-outlined"
          onClick={() => setgetId(null)}
        >
          close
        </span>
      </button>
      <h4 className="mem-heading">Add Client</h4>
      <div className="selected_option">
        <div>
          <label>Select Client</label>
          {/* <Select2
            name="client_id"
            // defaultValue={addClientDetails && addClientDetails?.client?.id}
            value={formData.client_id || addClientDetails && addClientDetails?.client?.id}
            onChange={(e) =>
              setFormData({
                client_id: e.target.value,
              })
            }
            data={client.map((client) => ({
              id: client.id,
              text: client.combine,
            }))}
            options={{
              placeholder: 'Select an option',
              allowClear: true,
            }}
            required
          /> */}
          <Select
              name="client_id"
              value={selectedClient}
              onChange={(e) => {
                const selectedClientId = e.value;
                if (formData.client_id !== selectedClientId) {
                  setFormData((prevData) => ({
                    ...prevData,
                    client_id: selectedClientId,
                  }));
                }
              }}
              options={client ? client.map(client => ({
                value: client.id,
                label: client.combine,
              })) : []}
              // options={{
              //   placeholder: 'Select an option',
              //   allowClear: true,
              // }}
              required
            />

          <button
            className="add_new_card mt-3"
            disabled={formData.client_id == ''}
            onClick={addClientFunc}
          >
            Add Client
          </button>
        </div>
      </div>
    </div>
  );
};
